module.exports = __webpack_public_path__ + "src/assets/img/Congratulations.4263c060.svg";